export default __webpack_public_path__ + "static/media/Gauntlets of the Dauntless.ecb40df4.jpg";